import type { CSSProperties, ReactNode } from 'react';
import React, { Children } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  children?: ReactNode;
  className?: string;
  closeLabel?: string;
  id?: string;
  onClose?: () => void;
  style?: CSSProperties;
};
export const NavigationLargeElement = ({
  children,
  className,
  closeLabel,
  id,
  onClose,
  style,
}: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  return (
    <div
      className={classnames(
        'absolute end-0 top-full -mt-5 max-h-nav-large-sub overflow-y-auto bg-white p-15',
        className,
      )}
      id={id}
      style={style}
    >
      {closeLabel && (
        <button
          className="sr-only float-right mb-10 px-5 text-12 text-black focus:not-sr-only"
          onClick={onClose}
          type="button"
        >
          {closeLabel}
        </button>
      )}
      {children}
    </div>
  );
};
